import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import PurchaseOrderForm from './purchaseOrderForm'
import { PurchaseOrderStore, PurchaseOrderStoreActions, STATUS } from '../../stores/purchaseOrderStore'

export default class PurchaseOrderEdit extends Component {
  constructor(props) {
    super(props)
    this.stores = [PurchaseOrderStore]
    this.storeKeys = ['status']
  }
  componentDidMount() {
    PurchaseOrderStoreActions.getPurchaseOrderDetails(this.props.match.params.PurchaseOrderID)
  }
  componentDidUpdate() {
    if (this.state.status === STATUS.PRODUCT_SUCCESS) {
      toast.success('Successfully Updated', {
        autoClose: 7500,
        onClose: () => {
          PurchaseOrderStoreActions.clearFormToast()
        }
      })
      PurchaseOrderStoreActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.PRODUCT_ERROR) {
      toast.error('Error while updating product', {
        autoClose: 7500,
        onClose: () => {
          PurchaseOrderStoreActions.clearFormToast()
        }
      })
      PurchaseOrderStoreActions.clearFormToast()
    }
  }

  render() {
    return (
      <React.Fragment>
        <PurchaseOrderForm match={this.props.match} />
      </React.Fragment>
    )
  }
}
